import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ToastModule } from 'primeng/toast';
import { GlobalErrorHandlerService } from './Services/error-handler.service';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routes';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { IMqttServiceOptions, MqttModule } from 'ngx-mqtt';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { environment } from '../environments/environment';
import { MQTTservicesService } from './Services/mqqt-services.service';
import { MasterTrackingComponent } from './components/master-tracking/master-tracking.component';
import { TrackingComponent } from './components/tracking/tracking.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages'; // p-messages component
import { MessageServiceService } from './Services/message-service.service';
import { RippleModule } from 'primeng/ripple';
import { ErrorPageComponent } from './components/error-page/error-page.component';

const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
  hostname: environment.mqtt.hostName,
  path: environment.mqtt.path,
  protocol: environment.mqtt.protocol === "wss" ? "wss" : "ws",
  clean: environment.mqtt.clean,
  connectTimeout: environment.mqtt.connectTimeout,
  clientId: environment.mqtt.clientId,
  username: environment.mqtt.userName,
  password: environment.mqtt.password,
  reconnectPeriod: environment.mqtt.reconnectPeriod,
  keepalive: environment.mqtt.keepalive
};

@NgModule({
  declarations: [
    AppComponent,
    TrackingComponent,
    MasterTrackingComponent,
    ErrorPageComponent
  ],
  imports: [
    HttpClientJsonpModule,
    HttpClientModule,
    BrowserModule,
    MqttModule.forRoot(MQTT_SERVICE_OPTIONS),
    AppRoutingModule,
    ScrollPanelModule,
    ToastModule,
    ButtonModule,
    MessagesModule,
    BrowserAnimationsModule,
    MessagesModule,
    MessageModule,
    DialogModule,
    BrowserAnimationsModule,
    ButtonModule,
    RippleModule,
  ],
  providers: [MQTTservicesService, MessageService, MessageServiceService, { provide: ErrorHandler, useClass: GlobalErrorHandlerService }],
  bootstrap: [AppComponent]
})
export class AppModule { }       
